import { Unlink } from 'almanac-ui/icons/16'
import { ReactComponent as Link } from 'assets/icons/link16.svg'
import { LinkPrompt } from 'common/Prose/Prompts/LinkPrompt/LinkPrompt'
import { removeLink } from 'common/Prose/Prompts/LinkPrompt/removeLink'
import { applyLinkToSelection } from 'common/Prose/utils/link'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { schema } from 'prose-core'
import { getMarkBoundaries } from 'proseShared/utils/getMarkBoundaries'
import { EditorView } from 'prosemirror-view'
import { useContext } from 'react'
import { AlmanacEditorStateContext } from 'stores/EditorState'
import { ArticleFlat } from 'types'
import { ProseDropdownPrompt } from '../ProseDropdownPrompt/ProseDropdownPrompt'
import Styles from './LinkInlineFormatButton.module.scss'
import ButtonStyles from '../Buttons.module.scss'

export type LinkInlineFormatButtonProps = {
  view: EditorView
  article: ArticleFlat
  runItemKey?: string
  withLabel?: boolean
}

export const HyperlinkItemKey = 'hyperlink'

export const LinkInlineFormatButton = observer(function LinkInlineFormatButton({
  view,
  article,
  runItemKey,
  withLabel,
}: LinkInlineFormatButtonProps) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!
  const { from, to } = computed(() => almanacState.selection).get()

  const hasActiveLink = computed(() => almanacState.activeMarks.has(schema.marks.link)).get()

  const runNow = runItemKey === HyperlinkItemKey

  if (hasActiveLink) {
    const linkPosition = getMarkBoundaries(view.state.selection.$from, view.state.schema.marks.link)

    return (
      <InlineFormatButton onPress={removeLink({ view, linkPosition })} active>
        <Unlink />
      </InlineFormatButton>
    )
  }

  return (
    <ProseDropdownPrompt
      view={view}
      anchorChildren={
        <div className={ButtonStyles.anchor}>
          <Link /> {withLabel && <span className={ButtonStyles.label}>Link</span>}
        </div>
      }
      label="Hyperlink"
      shortcutKeys="K"
      shortcutModifiers={['Mod']}
      forceOpen={runNow}
      promptContainerClassName={Styles.promptContainer}
      dropdownComponent={(close) => {
        const handleClose = () => {
          close()
          view.focus()
        }

        // Switch from unlink to edit soon, but have to discuss how to handle selection with multiple links
        // if (hasActiveLink) {
        //   const defaults = {
        //     text: view.state.doc.textBetween(linkPosition.from, linkPosition.to),
        //     query: '',
        //   }
        //   return (
        //     <LinkPrompt
        //       article={article}
        //       close={handleClose}
        //       className={Styles.linkPrompt}
        //       callback={editLink({ view, linkPosition })}
        //       initialText={defaults.text}
        //       defaults={defaults}
        //     />
        //   )
        // }
        return (
          <LinkPrompt
            article={article}
            close={handleClose}
            callback={({ link, text }) => applyLinkToSelection(view, { link, text })}
            initialText={view.state.doc.textBetween(from, to)}
          />
        )
      }}
    />
  )
})
